import React, { useState } from 'react';
import './index.less';
import classNames from 'classnames';
import { evaluate } from 'mathjs';

const btns = [
	['AC', 'del', '%', '÷'],
	['7', '8', '9', '×'],
	['4', '5', '6', '−'],
	['1', '2', '3', '+'],
	['0', '.', '='],
];

interface IProps {
	closed: () => void;
}

const opMap: Record<string, string> = {
	'÷': '/',
	'×': '*',
	'−': '-',
	'+': '+',
};

const EnCalculator: React.FC<IProps> = props => {
	const [display, setDisplay] = useState('0');
	const [expression, setExpression] = useState('');
	const [justEvaluated, setJustEvaluated] = useState(false);

	const handleClick = (btn: string) => {
		if (/\d/.test(btn)) {
			if (justEvaluated) {
				setDisplay(btn);
				setExpression(btn);
				setJustEvaluated(false);
				return;
			}
			if (display === '0') {
				setDisplay(btn);
				setExpression(expression === '' ? btn : expression + btn);
			} else {
				setDisplay(display + btn);
				setExpression(expression + btn);
			}
			return;
		}
		if (btn === '.') {
			if (justEvaluated) {
				setDisplay('0.');
				setExpression('0.');
				setJustEvaluated(false);
				return;
			}
			if (!display.includes('.')) {
				setDisplay(display + '.');
				setExpression(expression + '.');
			}
			return;
		}
		if (btn === 'AC') {
			setDisplay('0');
			setExpression('');
			setJustEvaluated(false);
			return;
		}
		if (btn === 'del') {
			if (justEvaluated) return;
			if (display.length === 1) setDisplay('0');
			else setDisplay(display.slice(0, -1));
			setExpression(expression.slice(0, -1));
			return;
		}
		if (btn === '%') {
			// 仅对当前数字百分比
			try {
				const val = parseFloat(display) / 100;
				setDisplay(val.toString());
				setExpression(expression + '%');
				setJustEvaluated(false);
			} catch {
				setDisplay('Error');
			}
			return;
		}
		if (btn === '=') {
			try {
				let expr = expression.replace(/÷/g, '/').replace(/×/g, '*').replace(/−/g, '-');
				// 处理表达式末尾为运算符的情况
				if (/[-+*/.]$/.test(expr)) expr = expr.slice(0, -1);
				const result = evaluate(expr);
				setDisplay(result.toString());
				setExpression(expression + '=' + result);
				setJustEvaluated(true);
			} catch {
				setDisplay('Error');
				setJustEvaluated(true);
			}
			return;
		}
		if (['+', '−', '×', '÷'].includes(btn)) {
			if (justEvaluated) {
				setExpression(display + btn);
				setJustEvaluated(false);
				setDisplay('0');
				return;
			}
			// 连续输入运算符时替换
			if (['+', '−', '×', '÷'].includes(expression.slice(-1))) {
				setExpression(expression.slice(0, -1) + btn);
			} else {
				setExpression(expression + btn);
			}
			setDisplay('0');
			return;
		}
	};

	return (
		<div className="sub-tiku__en-calc-root">
			<div className="sub-tiku__en-calc-header">
				<span className="sub-tiku__en-calc-close" onClick={props.closed}>×</span>
				<div className="sub-tiku__en-calc-expression">{expression}</div>
				<div className="sub-tiku__en-calc-display">{display}</div>
			</div>
			<div className="sub-tiku__en-calc-btns">
				{btns.map((row, i) => (
					<div className="sub-tiku__en-calc-row" key={i}>
						{row.map((btn, j) => (
							<button
								key={btn}
								onClick={() => handleClick(btn)}
								className={classNames('sub-tiku__en-calc-btn', {
									'sub-tiku__text-large': ['÷', '×', '−', '+', '=', '.'].includes(btn),
									'sub-tiku__opartor-btn': ['÷', '×', '−', '+', '='].includes(btn),
									'sub-tiku__large-btn': btn === '0',
									'sub-tiku__first-row-btn': ['AC', 'del', '%'].includes(btn),
								})}
							>
								{btn}
							</button>
						))}
					</div>
				))}
			</div>
		</div>
	);
};

export default EnCalculator; 